import Mock from 'mockjs'
//使用mockjs模拟数据
const listData = Mock.mock({
  'code': 0,
  'msg': '成功',
  'data': {
    'img_lists':[
      {image_url:'../../static/banner.png',link:'http://baidu.com'},
      {image_url:'../../static/banner.png',link:'http://baidu.com'}
    ]
  }
})
 
Mock.mock('/getListData', 'post', listData)


// WEBPACK FOOTER //
// ./src/utils/mock.js